const highlightParam = `
  color: #1AA9BF;
  font-weight: 600
`;

const highlightNotFound = `
  color: #ef4444;
  font-weight: 600
`;

const buildParamElement = (param: string) => {
  return String(
    `<span style="${param ? highlightParam : highlightNotFound}">${
      param ? param : "X"
    }</span>`
  );
};

export const buildMessage = (message, row: Row): string =>
  (message || "").replace(/{([\w\s]+)}/g, (match: string, p1: string) => {
    const param = row[p1];
    return String(
      `<span style="${param ? highlightParam : highlightNotFound}">${
        param || "X"
      }</span>`
    );
  });

export const buildMessageTemplate = (text: string, params: string[]) => {
  let c = 0;
  return text.replace(/\{\{\d\}\}/g, (match, p1) =>
    buildParamElement(params[c++])
  );
};
interface Row {
  [key: string]: string;
}
